import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Button, Table } from 'antd';
import '../../../assets/api.css'
import { toJS } from 'mobx';
@inject('connectionMonitorStore')
@observer
class FormModal extends Component {
  state = {
    detailsModalVisible: false,
    record: null
  }
  componentDidMount() {
  }
  handleDetails=(record)=>{
    // this.setState({
    //   detailsModalVisible: true,
    //   record: record
    // })
  }
  handleCancel=()=>{
    this.setState({
      detailsModalVisible: false
    })
  }
  handlePageChange = (page, pageSize) => {
    const { connectionMonitorStore } = this.props;
    connectionMonitorStore.onChangePageNumAction(page, pageSize);
  }
  render() {
    const { addModalVisible, handleCancel, record } = this.props
    return (
      <>
        <Modal
          title="Process Details"
          closable={true}
          visible={addModalVisible}
          onOk={null}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          footer={null}
          width='80%'
        >
          <Table className='searchResult' dataSource={toJS(record.processDetails)} pagination={false} rowKey="id" size="small" bordered>
            <Table.Column title='Status' dataIndex="status" key="status" />
            <Table.Column title='Time Stamp' dataIndex="timeStamp" key="timeStamp" />
            <Table.Column title='Message ID' dataIndex="messageID" key="messageID" render={(text, record)=>(
              <>
                <Button onClick={() => this.handleDetails(record)} type='link'>{record.messageID}</Button>
              </>)} />
            <Table.Column title='Process Log' dataIndex="processLog" key="processLog" />
          </Table>
        </Modal>
        {this.state.detailsModalVisible?<FormModal
          addModalVisible={this.state.detailsModalVisible}
          handleCancel={this.handleCancel}
          record={this.state.record}
        />:null}
      </>
    );
  }
}

export default FormModal;
